// Novo Pedido do Delivery pelo teclado (pedido do dono, 29/09/2026 — o mesmo
// jeito do Balcão). Só age com a página aberta e SEM popup aberto, e só quando
// o cursor não está num campo de texto (lá as teclas são do campo) — menos as
// teclas F e os campos marcados com `data-enter-avanca` (o troco).
//   Todas as etapas: F2 = busca de cliente · Esc = etapa anterior (na 1ª, nada)
//   1 Carrinho: Enter = Próximo (precisa de cliente)
//   2 Entrega:  F3 = Entrega · F4 = Retirada (só F3/F4 e o clique trocam —
//               Tab e ← → não trocam mais, 30/09/2026: mudavam sem querer) ·
//               ↑ ↓ escolhem o endereço salvo (depois do último, "Cadastrar novo
//               endereço" — Enter abre; no formulário Enter pula de campo em campo
//               e no último avança) · Enter = Próximo (precisa de endereço)
//   3 Pagamento: Tab/setas acendem a forma · Enter escolhe a acesa; com a forma
//               escolhida e acesa, Enter cria o pedido
// O Enter do leitor de código de barras (rajada < 80 ms) não conta.
import { useEffect, useRef, useState } from "react";

const RAJADA_MS = 80;
const CAMPOS = ["INPUT", "TEXTAREA", "SELECT"];

export function useTeclasNovoPedido(p) {
  const pRef = useRef(p);
  pRef.current = p;
  const [acesa, setAcesa] = useState(0);
  // A forma escolhida (clique ou Enter) passa a ser a acesa.
  useEffect(() => {
    const i = p.formas.findIndex((f) => (f.code || f.id) === p.formaPagamento);
    if (i >= 0) setAcesa(i);
  }, [p.formaPagamento, p.formas]);
  const acesaRef = useRef(acesa);
  acesaRef.current = Math.min(acesa, Math.max(p.formas.length - 1, 0));

  useEffect(() => {
    if (!p.open) return undefined;
    let ultimaTecla = -Infinity;
    const registrar = (e) => { if (e.key && e.key.length === 1) ultimaTecla = e.timeStamp; };
    const agir = (e) => {
      const x = pRef.current;
      if (e.defaultPrevented || e.repeat || e.ctrlKey || e.altKey || e.metaKey) return;
      if (e.target?.closest?.('[role="dialog"], [role="alertdialog"]')) return;
      if (document.querySelector('[role="dialog"], [role="alertdialog"]')) return;
      const k = e.key;
      const tecla = k.length > 1 && /^F\d+$/.test(k);
      const emCampo = CAMPOS.includes(e.target?.tagName) && !e.target.closest?.("[data-enter-avanca]");
      if (k === "Enter" && e.timeStamp - ultimaTecla < RAJADA_MS) return;
      if (emCampo && !tecla && k !== "Escape") return;
      // Enter num botão em foco (ex.: "Cadastrar novo endereço") é do botão.
      if (k === "Enter" && e.target?.tagName === "BUTTON") return;
      const feito = (() => {
        if (k === "F2") { x.clienteSearchRef.current?.focus(); return true; }
        if (k === "Escape") {
          if (emCampo) { e.target.blur(); return true; }
          if (x.cartStep > 1) { x.setCartStep(x.cartStep - 1); return true; }
          return false;
        }
        if (x.cartStep === 1) return k === "Enter" ? (x.avancarEtapa(), true) : false;
        if (x.cartStep === 2) {
          if (x.showNewAddressForm) return false;
          if (k === "F3") { x.setTipoEntrega("delivery"); return true; }
          if (k === "F4") { x.setTipoEntrega("pickup"); return true; }
          if ((k === "ArrowDown" || k === "ArrowUp") && x.tipoEntrega === "delivery") {
            // ↓ passa pelos endereços salvos e, depois do último, vai para
            // "Cadastrar novo endereço" (Enter abre o formulário, 30/09/2026).
            const novo = document.querySelector('[data-e2e="np-novo-endereco"]');
            const noNovo = novo && document.activeElement === novo;
            const n = x.enderecos.length;
            const atual = x.enderecos.findIndex((a) => a.rua === x.endereco.rua && a.numero === x.endereco.numero);
            if (k === "ArrowDown") {
              if (noNovo) return true;
              if (!n || atual === n - 1) { novo?.focus(); return true; }
              x.escolherEndereco(x.enderecos[atual < 0 ? 0 : atual + 1]);
              return true;
            }
            if (noNovo) { novo.blur(); if (n) x.escolherEndereco(x.enderecos[n - 1]); return true; }
            if (!n) return false;
            x.escolherEndereco(x.enderecos[atual <= 0 ? n - 1 : atual - 1]);
            return true;
          }
          if (k === "Enter") { x.avancarEtapa(); return true; }
          return false;
        }
        if (x.cartStep === 3) {
          const n = x.formas.length;
          if (x.cpSplitPayment || n === 0) return k === "Enter" && x.podeCriar ? (x.handleSubmit(), true) : false;
          if (["Tab", "ArrowRight", "ArrowDown"].includes(k)) { setAcesa((acesaRef.current + (k === "Tab" && e.shiftKey ? n - 1 : 1)) % n); return true; }
          if (["ArrowLeft", "ArrowUp"].includes(k)) { setAcesa((acesaRef.current + n - 1) % n); return true; }
          if (k === "Enter") {
            const alvo = x.formas[acesaRef.current];
            const id = alvo && (alvo.code || alvo.id);
            if (id && id !== x.formaPagamento) { x.setFormaPagamento(id); return true; }
            if (x.podeCriar) { x.handleSubmit(); return true; }
            return false;
          }
        }
        return false;
      })();
      if (feito) e.preventDefault();
    };
    window.addEventListener("keydown", registrar, true);
    window.addEventListener("keydown", agir);
    return () => { window.removeEventListener("keydown", registrar, true); window.removeEventListener("keydown", agir); };
  }, [p.open]);

  return { formaAcesa: p.cartStep === 3 && !p.cpSplitPayment ? acesaRef.current : null };
}
